import React from 'react';
import './styles.scss';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useBranding } from 'hooks/useBranding';
import { snakeCase } from 'lodash';
import { replaceBrandText } from 'utilities/lang';

const PublicFooter = ({ className }) => {
  const { domainConfig } = useBranding();

  return (
    <div id="public-footer" className={cn(className)}>
      <div className="footer-wrapper">
        <div className="text-sm">
          <FormattedMessage
            id="public_footer.copyright"
            values={{
              YEAR: new Date().getFullYear(),
              domainName: (
                <FormattedMessage
                  id={`header.${snakeCase(domainConfig.name)}`}
                  defaultMessage={domainConfig.name}
                />
              ),
            }}
          />
        </div>
        <div className="text-sm flex-space-between">
          <a
            href={replaceBrandText("https://affiliates.turnitbluedigital.com/register")}
            target="_blank"
            className="text-sm"
          >
            <FormattedMessage id="public_footer.affiliate_program" />
          </a>
          <a
            href={replaceBrandText("https://turnitbluedigital.com/helpdocs")}
            target="_blank"
            className="text-sm ml-40"
          >
            <FormattedMessage id="public_footer.help_docs" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default PublicFooter;
